//* 动画库
import { gsap } from "gsap";
//* 组件库
import { utility } from "various-ui";
//* 全局属性
import type { NavigateToRoute } from "@/utils/router/src/types";

export const useComposable = () => {
    //* 获取Route
    const route = useRoute();

    //* 响应式变量
    const refs = {
        keyword: ref<string>(""),

        searchNode: ref<HTMLElement>(),
        searchVisible: ref<boolean>(false),
        searchWindowNode: ref<HTMLElement>(),
    };

    const options = {
        type: {
            tool: "Tool",
            gene: "Gene",
            model: "Model",
            disease: "Disease",
            mutation: "Mutation",
        } as { [name: string]: string },
    };

    //* 函数列表
    const methods = {
        //* 路由
        route: (data: any) => {
            if (data.search_type == "custom") return data.link;
            else {
                return { name: utility.upperFirst(data.search_type), params: { id: data.value_id } };
            }
        },

        //* 搜索函数
        search: (context: string, mode: string, id?: string) => {
            //* 数据初始化
            const keyword = context?.trim();
            //* 检测是否存在关键词
            if (!keyword) return;
            //* 有返回id和类型 直接跳转到详情页
            if (!options.type[mode]) open(routerResolve({ name: "Search", query: { keyword: keyword, date: new Date().getTime() } }).href as string);
            else {
                const config = { mode: options.type[mode], route: {} as string | NavigateToRoute };
                if (!id) config.route = { name: "Search" + config.mode, query: { keyword: keyword, date: new Date().getTime() } };
                else {
                    if (config.mode == "Tool") config.route = id;
                    else {
                        config.route = { name: config.mode, params: { id: id } };
                    }
                }

                open(routerResolve(config.route).href as string);
            }
        },

        //* 入场前样式调整
        entrancePreAnimation: (el: Element) => {
            gsap.set(el, { opacity: 0 });
            if (refs.searchNode.value) {
                gsap.set(refs.searchNode.value, { yPercent: -100 });
            }
        },

        //* 入场动画
        entranceAnimation: (el: Element, done: () => void) => {
            if (refs.searchNode.value) {
                gsap.to(refs.searchNode.value, { duration: 0.3, yPercent: 0 });
            }

            gsap.to(el, {
                duration: 0.3,
                opacity: 1,
                onComplete: () => {
                    done && done();
                },
            });
        },

        //* 离场动画
        departureAnimation: (el: Element, done: () => void) => {
            if (refs.searchNode.value) {
                gsap.to(refs.searchNode.value, { duration: 0.3, yPercent: -100 });
            }

            gsap.to(el, {
                duration: 0.3,
                opacity: 0,
                onComplete: () => {
                    done && done();
                },
            });
        },
    };

    //* 侦听器
    const watchs = {
        stop: watch(
            () => route.fullPath,
            () => {
                refs.searchVisible.value = false;
            }
        ),

        stopWheel: watch(refs.searchVisible, () => {
            if (refs.searchVisible.value) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        }),
    };

    return { refs, watchs, methods };
};
